export interface TerrainType {
  id: number
  name: string
  color: number
  walkable: boolean
  buildable: boolean
  resource?: 'compute' | 'data' | 'energy'
  gatherRate?: number  // resources per second
  movementCost?: number  // multiplier (1 = normal, 2 = half speed)
}

export const TERRAIN: Record<string, TerrainType> = {
  GRASS: {
    id: 0,
    name: 'Plains',
    color: 0x1a2f1a,
    walkable: true,
    buildable: true,
    movementCost: 1
  },
  WATER: {
    id: 1,
    name: 'Data Ocean',
    color: 0x0a1a2e,
    walkable: false,
    buildable: false
  },
  MOUNTAIN: {
    id: 2,
    name: 'Silicon Peaks',
    color: 0x2a2a3a,
    walkable: false,
    buildable: false
  },
  FOREST: {
    id: 3,
    name: 'Data Forest',
    color: 0x0f2f1f,
    walkable: true,
    buildable: true,
    resource: 'data',
    gatherRate: 2,
    movementCost: 1.2
  },
  COMPUTE_NODE: {
    id: 4,
    name: 'Compute Node',
    color: 0x1a1a2a,
    walkable: true,
    buildable: true,
    resource: 'compute',
    gatherRate: 2.5,
    movementCost: 1
  },
  ENERGY_WELL: {
    id: 5,
    name: 'Energy Well',
    color: 0x2a1a0a,
    walkable: true,
    buildable: true,
    resource: 'energy',
    gatherRate: 1.5,
    movementCost: 1.1
  }
}

export function getTerrainById(id: number): TerrainType | undefined {
  return Object.values(TERRAIN).find(t => t.id === id)
}

export function getTerrainByName(name: string): TerrainType | undefined {
  return TERRAIN[name]
}

export function isWalkable(terrainId: number): boolean {
  const terrain = getTerrainById(terrainId)
  return terrain?.walkable ?? false
}

export function isBuildable(terrainId: number): boolean {
  const terrain = getTerrainById(terrainId)
  return terrain?.buildable ?? false
}
